/** Chuỗi hiển thị của trang danh sách lịch phát thanh (`/lich-phat`, theo mẫu tỉnh Lào Cai). */
export const viDanhSachLichPhat = {
  tieuDe: 'Lịch phát thanh',
  diaBan: 'Địa bàn',
  toanTinh: 'Toàn tỉnh',
  timDiaBan: 'Tìm địa bàn…',
  tenLich: 'Tên lịch',
  nhapTenLich: 'Nhập tên lịch phát',
  timKiem: 'Tìm theo tên lịch',
  trangThai: 'Trạng thái',
  chonTrangThai: 'Chọn trạng thái',
  hieuLuc: {
    con_hieu_luc: 'Còn hiệu lực',
    het_hieu_luc: 'Hết hiệu lực',
    da_huy: 'Đã hủy',
  },
  daDuyet: 'Đã duyệt -',
  ngayBatDau: 'Ngày bắt đầu',
  ngayKetThuc: 'Ngày kết thúc',
  den: '→',
  taiLai: 'Tải lại danh sách',
  themMoi: 'Thêm mới lịch',
  cot: {
    cham: '#',
    stt: 'STT',
    ngayCapNhat: 'Ngày cập nhật',
    tenLich: 'Tên lịch',
    trangThai: 'Trạng thái',
    diaBan: 'Địa bàn',
    thietBi: 'Thiết bị',
    ngayPhat: 'Ngày phát',
    nguoiTao: 'Người tạo',
    thaoTac: 'Thao tác',
  },
  tatCa: 'Tất cả',
  soNgay: '{so} ngày',
  huy: 'Hủy lịch',
  huyNhan: 'Hủy lịch {ten}',
  sua: 'Chỉnh sửa',
  suaNhan: 'Chỉnh sửa lịch {ten}',
  phat: 'Phát lịch',
  phatNhan: 'Gửi lại lịch {ten} xuống thiết bị',
  dangPhat: 'Đang gửi…',
  phatThanhCong: 'Đã gửi lại lịch "{ten}" tới {so} nhà cung cấp (qua bộ tương thích).',
  phatKhongCoNcc:
    'Lịch "{ten}" không có thiết bị qua bộ tương thích; thiết bị kết nối trực tiếp nhận lệnh khi tới giờ phát.',
  phatCoLoi: 'Đã gửi lại lịch "{ten}", {loi} lỗi: {chiTiet}',
  phatLoi: 'Không gửi lại được lịch: {loi}',
  huyTieuDe: 'Hủy lịch phát',
  huyHeQua:
    'Hủy lịch "{ten}": {soNgay} ngày phát trên {thietBi} sẽ không còn được thực thi. Không hoàn tác được.',
  huyTatCaThietBi: 'tất cả thiết bị của địa bàn {diaBan}',
  huySoThietBi: '{so} thiết bị',
  huyThucHien: 'Hủy lịch',
  huyThanhCong: 'Đã hủy lịch "{ten}".',
  huyLoi: 'Không hủy được lịch: {loi}',
  rongMoTa: 'Chưa có lịch phát nào. Bấm "Thêm mới lịch" để lập lịch.',
} as const;
